/**
 * Listing remote URL API endpoint schemas
 */
import { z } from 'zod';

// Request schema for GET query parameters
export const ListingRemoteUrlRequestSchema = z.object({
  listingId: z.coerce.number().positive('listingId is required'),
});

export type ListingRemoteUrlRequest = z.infer<typeof ListingRemoteUrlRequestSchema>;

// Response schema
export const ListingRemoteUrlResponseSchema = z.object({
  remote_url: z.string().nullable(),
});

export type ListingRemoteUrlResponse = z.infer<typeof ListingRemoteUrlResponseSchema>;

// Error response schema
export const ListingRemoteUrlErrorResponseSchema = z.object({
  error: z.string(),
});

export type ListingRemoteUrlErrorResponse = z.infer<typeof ListingRemoteUrlErrorResponseSchema>;
